import { AbstractTransition } from 'starting-blocks'
import gsap from 'gsap'

export default class FadeTransition extends AbstractTransition {
  start() {
    this.distance = -20
    this.duration = 0.3

    Promise.all([this.newPageLoading, this.fadeOut()]).then(this.fadeIn.bind(this))
  }

  fadeOut() {
    return new Promise((resolve) => {
      gsap.to(this.oldPage.rootElement, {
        duration: this.duration,
        y: this.distance,
        alpha: 0,
        onComplete: () => {
          resolve()
        },
      })
    })
  }

  fadeIn() {
    this.oldPage.rootElement.style.display = 'none'

    this.newPage.rootElement.style.visibility = 'visible'
    this.newPage.rootElement.style.opacity = '0'

    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0

    gsap.fromTo(
      this.newPage.rootElement,
      {
        opacity: 0,
        y: -this.distance,
      },
      {
        duration: this.duration,
        y: 0,
        opacity: 1,
        onComplete: () => {
          this.done()
        },
      },
    )
  }
}
